module.exports = __webpack_public_path__ + "static/media/snipcart-logo.08559b06.png";